import React from 'react';

import {useStore} from 'effector-react';
import i18next from 'i18next';
import {useTranslation} from 'react-i18next';

import {validateCode} from 'api';
import {BackTo} from 'components/common/BackTo';
import {Stepper} from 'components/ui-kit/Stepper';
import {DocumentReportType} from 'core/dictionaries';
import {ROUTE} from 'core/routes';
import {createBlockingDocument, DocumentsCreateGate, step$} from 'models/documents/create';
import {BlockingType} from 'types/products-blocking';
import {CodeRequestType, CodeResponseType} from 'types/validation';

import {ProductCodes} from '../common/products';
import {ContentWrapper} from '../common/styled';

import {DocumentForm} from './form';

export const CreateBlocking = () => {
    const {t} = useTranslation();
    const step = useStore(step$);

    const validation = async (markingCode: string, data: CodeResponseType['info'][]) => {
        const errors: string[] = [];

        try {
            const payload: CodeRequestType = {
                type: (BlockingType.BLOCKING as unknown) as DocumentReportType,
                markingCode,
            };
            const codeData = (await validateCode(payload)).data;
            errors.push(...codeData.errors.map((e) => e.message));

            if (data.find((d) => d.identityCode === codeData.info.identityCode))
                errors.push(i18next.t('components.scan.errors.double'));

            return {errors, codeData: codeData.info};
        } catch (e) {
            console.error(e);
            errors.push('Invalid code');
            return {errors, codeData: null};
        }
    };

    return (
        <>
            <BackTo to={ROUTE.DOCUMENTS_BLOCKING}>{t('pages.documents.back')}</BackTo>
            <ContentWrapper>
                <h1>{t('pages.documents.blocking.newDocumentBlocking')}</h1>
                <DocumentsCreateGate />
                <Stepper
                    steps={[
                        {
                            label: t('pages.documents.blocking.stepOne'),
                            component: <DocumentForm />,
                        },
                        {
                            label: t('pages.documents.blocking.stepTwo'),
                            component: (
                                <ProductCodes
                                    createDocument={createBlockingDocument}
                                    validation={validation}
                                />
                            ),
                        },
                    ]}
                    activeStep={step}
                />
            </ContentWrapper>
        </>
    );
};
